import confetti from "canvas-confetti";

import { triggerGoogleEvent } from "../analytics";

import { faDollarSign, faHashtag } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  formatDecimal,
  formatDollars,
  letterSBoolean,
} from "@aclymatepackages/formatters";

export const fireConfetti = () => {
  const fire = (particleRatio, opts) => {
    confetti({
      ...opts,
      particleCount: Math.floor(200 * particleRatio),
      origin: { y: 0.7, x: 0.3 },
      zIndex: 9999,
    });
  };

  fire(0.25, {
    spread: 26,
    startVelocity: 55,
  });
  fire(0.2, {
    spread: 60,
  });
  fire(0.35, {
    spread: 100,
    decay: 0.91,
    scalar: 0.8,
  });
  fire(0.1, {
    spread: 120,
    startVelocity: 25,
    decay: 0.92,
    scalar: 1.2,
  });
  fire(0.1, {
    spread: 120,
    startVelocity: 45,
  });
};

export const googlePurchaseTracking = (
  event,
  { portfolio, purchaseDollars, purchaseTons } = {},
  otherData,
) => {
  const { id, name } = portfolio || {};

  return triggerGoogleEvent(
    event,
    {
      item_id: id,
      item_name: name,
      price: purchaseDollars,
      quantity: purchaseTons,
    },
    otherData,
  );
};

export const generateDisplayIcons = ({
  certificationLevel,
  purchaseDollars,
  purchaseTons,
  discountPrice,
  badge,
  badgeYears,
  badgeName,
}) => {
  const badgeDisplayIcon =
    certificationLevel || !badge
      ? []
      : [
          {
            icon: (
              <img
                alt="offsets badge"
                src={`/images/badges/svg/${badge}-offsets.svg`}
                style={{ width: "100px" }}
              />
            ),
            title: badgeName,
            subtitle: `You'll earn your ${badgeName} badge for ${badgeYears} year${letterSBoolean(
              badgeYears,
            )}`,
          },
        ];

  const buildPriceTitle = () => {
    if (!discountPrice) {
      return formatDollars(purchaseDollars);
    }

    return (
      <>
        <span style={{ textDecoration: "line-through" }}>
          {formatDollars(purchaseDollars)}
        </span>
        {` ${formatDollars(discountPrice)}`}
      </>
    );
  };

  return [
    {
      icon: <FontAwesomeIcon icon={faDollarSign} size="3x" />,
      title: buildPriceTitle(),
      subtitle: "This is how much you're paying for your offsets.",
    },
    {
      icon: <FontAwesomeIcon icon={faHashtag} size="3x" />,
      title: `${formatDecimal(purchaseTons)}`,
      subtitle: "This is how many tonnes of offsets you're buying.",
    },
    ...badgeDisplayIcon,
  ];
};
